(() => {
  const initQuantity = (scope) => {
    scope.querySelectorAll('[data-dnc-qty]:not([data-ready])').forEach((quantity) => {
      quantity.dataset.ready = 'true';
      const input = quantity.querySelector('input');
      if (!input) return;
      quantity.querySelector('[data-dnc-minus]')?.addEventListener('click', () => {
        input.value = Math.max(1, Number(input.value || 1) - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      quantity.querySelector('[data-dnc-plus]')?.addEventListener('click', () => {
        input.value = Math.min(5, Number(input.value || 1) + 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  };

  const initObject = (scope) => {
    scope.querySelectorAll('[data-dnc-object]:not([data-ready])').forEach((object) => {
      object.dataset.ready = 'true';
      const scene = object.querySelector('[data-dnc-object-scene]');
      const card = object.querySelector('[data-dnc-object-card]');
      const rotate = object.querySelector('[data-dnc-rotate]');
      if (!scene || !card) return;

      let rotation = -14;
      let tilt = -1.5;
      let startX = 0;
      let startY = 0;
      let startRotation = rotation;
      let startTilt = tilt;
      let dragging = false;
      let userControlled = false;

      const render = () => {
        card.style.setProperty('--dnc-rotation', `${rotation}deg`);
        card.style.setProperty('--dnc-tilt', `${tilt}deg`);
      };
      const stop = () => {
        if (!dragging) return;
        dragging = false;
        scene.classList.remove('is-dragging');
        card.style.setProperty('--dnc-tilt', `${Math.max(-7, Math.min(7, tilt))}deg`);
      };

      scene.addEventListener('pointerdown', (event) => {
        dragging = true;
        userControlled = true;
        startX = event.clientX;
        startY = event.clientY;
        startRotation = rotation;
        startTilt = tilt;
        scene.classList.add('is-dragging');
        scene.setPointerCapture?.(event.pointerId);
      });
      scene.addEventListener('pointermove', (event) => {
        if (!dragging) return;
        rotation = startRotation + (event.clientX - startX) * .72;
        tilt = Math.max(-10, Math.min(10, startTilt - (event.clientY - startY) * .12));
        render();
      });
      scene.addEventListener('pointerup', stop);
      scene.addEventListener('pointercancel', stop);
      scene.addEventListener('lostpointercapture', stop);
      rotate?.addEventListener('click', () => {
        userControlled = true;
        rotation = Math.round((rotation + 180) / 180) * 180 - 14;
        tilt = -1.5;
        render();
      });

      render();
    });
  };

  const initAccordions = (scope) => {
    scope.querySelectorAll('.dnc-faq__list, .dnc-pdp__accordion').forEach((list) => {
      list.querySelectorAll('details:not([data-ready])').forEach((detail) => {
        detail.dataset.ready = 'true';
        detail.addEventListener('toggle', () => {
          if (!detail.open) return;
          list.querySelectorAll('details[open]').forEach((other) => {
            if (other !== detail) other.removeAttribute('open');
          });
        });
      });
    });
  };

  const initCountdowns = (scope) => {
    scope.querySelectorAll('[data-dnc-countdown]:not([data-ready])').forEach((countdown) => {
      countdown.dataset.ready = 'true';
      const deadline = new Date(countdown.dataset.deadline || '2026-10-31T23:59:59+01:00').getTime();
      const fields = {
        days: countdown.querySelector('[data-dnc-days]'),
        hours: countdown.querySelector('[data-dnc-hours]'),
        minutes: countdown.querySelector('[data-dnc-minutes]'),
        seconds: countdown.querySelector('[data-dnc-seconds]')
      };
      const pad = (value) => String(value).padStart(2, '0');
      const update = () => {
        const remaining = Math.max(0, deadline - Date.now());
        const days = Math.floor(remaining / 86400000);
        const hours = Math.floor((remaining % 86400000) / 3600000);
        const minutes = Math.floor((remaining % 3600000) / 60000);
        const seconds = Math.floor((remaining % 60000) / 1000);
        if (fields.days) fields.days.textContent = pad(days);
        if (fields.hours) fields.hours.textContent = pad(hours);
        if (fields.minutes) fields.minutes.textContent = pad(minutes);
        if (fields.seconds) fields.seconds.textContent = pad(seconds);
        countdown.classList.toggle('is-ended', remaining === 0);
      };
      update();
      const timer = window.setInterval(update, 1000);
      countdown.addEventListener('dnc:destroy', () => window.clearInterval(timer), { once: true });
    });
  };

  const initBrandTimelines = (scope) => {
    scope.querySelectorAll('[data-dnc-brand-timeline]:not([data-ready])').forEach((timeline) => {
      timeline.dataset.ready = 'true';
      const steps = Array.from(timeline.querySelectorAll('article'));
      const page = timeline.closest('[data-dnc-brand-page]') || timeline;
      let frame = 0;
      let manualIndex = null;
      let pinnedIndex = null;

      const paint = (active, progress) => {
        timeline.style.setProperty('--brand-progress', Math.max(0, Math.min(1, progress)).toFixed(4));
        steps.forEach((step, index) => {
          step.classList.toggle('is-active', index === active);
          step.classList.toggle('is-past', index < active);
        });
      };

      const update = () => {
        frame = 0;
        if (window.innerWidth < 750) {
          timeline.style.setProperty('--brand-progress', '1');
          steps.forEach((step) => step.classList.add('is-active'));
          return;
        }
        if (manualIndex !== null) {
          paint(manualIndex, manualIndex / Math.max(steps.length - 1, 1));
          return;
        }
        const rect = page.getBoundingClientRect();
        const viewport = window.innerHeight || 1;
        const raw = (106 - rect.top) / Math.max(rect.height - viewport, 1);
        const progress = Math.max(0, Math.min(1, raw));
        const active = Math.min(steps.length - 1, Math.round(progress * (steps.length - 1)));
        paint(active, progress);
      };
      const requestUpdate = () => {
        if (frame) return;
        frame = window.requestAnimationFrame(update);
      };
      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate, { passive: true });
      steps.forEach((step, index) => {
        step.tabIndex = 0;
        step.addEventListener('mouseenter', () => { manualIndex = index; requestUpdate(); });
        step.addEventListener('mouseleave', () => { manualIndex = pinnedIndex; requestUpdate(); });
        step.addEventListener('focus', () => { manualIndex = index; requestUpdate(); });
        step.addEventListener('blur', () => { manualIndex = pinnedIndex; requestUpdate(); });
        step.addEventListener('click', () => { pinnedIndex = index; manualIndex = index; requestUpdate(); });
        step.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          pinnedIndex = index;
          manualIndex = index;
          requestUpdate();
        });
      });
      update();
    });
  };

  const initScrollRoutes = (scope) => {
    scope.querySelectorAll('[data-dnc-scroll-route]:not([data-ready])').forEach((route) => {
      route.dataset.ready = 'true';
      const steps = Array.from(route.querySelectorAll('[data-dnc-route-step]'));
      const counter = route.querySelector('[data-dnc-route-count]');
      let frame = 0;

      const update = () => {
        frame = 0;
        if (window.innerWidth < 750) return;
        const rect = route.getBoundingClientRect();
        const travel = Math.max(1, rect.height - window.innerHeight);
        const progress = Math.max(0, Math.min(1, (106 - rect.top) / travel));
        const activeIndex = Math.min(steps.length - 1, Math.floor(progress * steps.length));
        route.style.setProperty('--route-progress-scale', progress.toFixed(4));
        route.style.setProperty('--route-progress-pct', `${(progress * 100).toFixed(2)}%`);
        steps.forEach((step, index) => step.classList.toggle('is-active', index === activeIndex));
        if (counter) counter.textContent = String(activeIndex + 1).padStart(2, '0');
      };
      const requestUpdate = () => {
        if (frame) return;
        frame = requestAnimationFrame(update);
      };

      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate, { passive: true });
      update();
    });
  };

  const init = (scope = document) => {
    initQuantity(scope);
    initObject(scope);
    initAccordions(scope);
    initScrollRoutes(scope);
    initCountdowns(scope);
    initBrandTimelines(scope);
  };

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
